/* 7AYAA — CRO polish layer.
   Header logo state and lightweight Add-to-Bag confirmation only.
   Core product JS owns variants, sticky buy and sold-out notify behavior. */
(function () {
  'use strict';

  var logoObserver = null;
  var addedFeedbackBound = false;

  function initHeaderLogo() {
    if (logoObserver) {
      logoObserver.disconnect();
      logoObserver = null;
    }

    var header = document.querySelector('[data-header]');
    if (!header) return;
    var img = header.querySelector('.s7-header__logo img');
    if (!img) return;

    var initial = img.getAttribute('src') || '';
    var light = '';
    var dark = '';
    if (initial.indexOf('7ayaa-logo-white') !== -1) {
      light = initial;
      dark = initial.replace('7ayaa-logo-white', '7ayaa-logo-dark');
    } else if (initial.indexOf('7ayaa-logo-dark') !== -1) {
      dark = initial;
      light = initial.replace('7ayaa-logo-dark', '7ayaa-logo-white');
    }
    if (!light || !dark) return;

    function sync() {
      var state = header.dataset.state;
      var target = state === 'over' || state === 'deep' ? light : dark;
      if (img.getAttribute('src') !== target) img.setAttribute('src', target);
    }

    sync();
    if ('MutationObserver' in window) {
      logoObserver = new MutationObserver(sync);
      logoObserver.observe(header, { attributes: true, attributeFilter: ['data-state'] });
    }
  }

  function initAddedFeedback() {
    if (addedFeedbackBound) return;
    addedFeedbackBound = true;

    document.addEventListener('s7:cart:added', function () {
      setTimeout(function () {
        var label = document.querySelector('[data-add-label]');
        var button = document.querySelector('[data-add-button]');
        var barLabel = document.querySelector('[data-bar-label]');
        var barButton = document.querySelector('[data-bar-cta]');
        var added = (window.s7Strings && window.s7Strings.added) || 'Added';
        var restore = label ? label.textContent : '';
        var restoreBar = barLabel ? barLabel.textContent : '';

        if (label) label.textContent = added;
        if (barLabel) barLabel.textContent = added;
        if (button) button.classList.add('is-added');
        if (barButton) barButton.classList.add('is-added');

        setTimeout(function () {
          if (label && restore) label.textContent = restore;
          if (barLabel && restoreBar) barLabel.textContent = restoreBar;
          if (button) button.classList.remove('is-added');
          if (barButton) barButton.classList.remove('is-added');
        }, 900);
      }, 0);
    });
  }

  function init() {
    initHeaderLogo();
    initAddedFeedback();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', initHeaderLogo);
})();
